import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { FilterQuery } from '../../repository/types'
import type { Product } from '../Product'
import type { IAction } from '../../action/IAction'

@InputType()
export class GetProductMinimumQuantityListArgs extends ActionArgs {
  @Field(() => ID)
  filter: FilterQuery<Product>
}

export interface IGetProductMinimumQuantityList extends IAction<Product[], GetProductMinimumQuantityListArgs> {}
